<template>
  <div class="flex items-center gap-2 my-1">
    <div class="shrink-0 rounded-md animate-pulse bg-gray-200 w-8 h-8"/>
    <div class="shrink-0 rounded-md animate-pulse bg-gray-200 w-48 h-5"/>
  </div>
</template>
